<template>
  <el-form
    :model="dataForm"
    :rules="dataRule"
    ref="dataForm"
    @keyup.enter.native="dataFormSubmitHandle()"
    label-width="145px"
  >
    <el-form-item :label="$t('GL.mobile')" prop="phone">
      <el-input v-model="dataForm.phone" disabled></el-input>
    </el-form-item>
    <el-form-item :label="$t('GL.oldPswd')" prop="oldPassword">
      <el-input v-model="dataForm.oldPassword" show-password></el-input>
    </el-form-item>
    <el-form-item :label="$t('GL.newPswd')" prop="newPassword">
      <el-input v-model="dataForm.newPassword" show-password></el-input>
    </el-form-item>
    <el-form-item :label="$t('GL.confirmPswd')" prop="confirmPassword">
      <el-input v-model="dataForm.confirmPassword" show-password></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import debounce from "lodash/debounce";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "EditPassword",
  data() {
    const passwordValidateSame = (rule, value, callback) => {
      if (value !== this.dataForm.newPassword) {
        callback(new Error(this.$t("GL.confirmPswdErrTip")));
      } else {
        callback();
      }
    };
    const passwordValidateText = (rule, value, callback) => {
      const patrn = /^(\w){6,20}$/;
      if (!patrn.exec(value)) {
        callback(new Error(this.$t("GL.pswdRules")));
      }
    };
    return {
      dataForm: {},
      dataRule: {
        phone: [
          {
            required: false,
            message: this.$t("GL.phoneRequired"),
            trigger: "change",
          },
        ],
        oldPassword: [
          {
            required: true,
            message: this.$t("GL.oldPswdRequired"),
            trigger: "change",
          },
        ],
        newPassword: [
          {
            required: true,
            message: this.$t("GL.newPswdRequired"),
            trigger: "change",
          },
          { validator: passwordValidateText, trigger: "blur" },
        ],
        confirmPassword: [
          {
            required: true,
            message: this.$t("GL.confirmPswdRequired"),
            trigger: "change",
          },
          { validator: passwordValidateSame, trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    setDataForm(dataForm = {}) {
      this.dataForm = cloneDeep(dataForm);
    },

    validateForm() {
      let validateResult = true;
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          validateResult = false;
        }
      });
      return validateResult;
    },
    updatePassword: debounce(
      function () {
        const validateResult = this.validateForm();
        if (validateResult) {
          const { newPassword, oldPassword } = this.dataForm;
          this.$request
            .post(`/hcp/teacherSpace/updatePassword`, {
              newPassword,
              oldPassword,
            })
            .then((res) => {
              if (!res) {
                this.$emit("saveResult", {
                  isSuccess: false,
                  message: res.message,
                });
                return;
              }
              this.$emit("saveResult", { isSuccess: true });
            });
        }
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/EditPassword.vue